import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from '../language.service';

export interface SmsDetailsData {
  patientName: string;
  smsSentTime: string;
  status: string;
  appointmentTime: string;
  confirmationLink: string;
  fullMessage: string;
  arrivalInfo: string;
  wasDeleted: boolean;
  dateChanged: boolean;
  totalUserChanges: number;
  totalPatientChanges: number;
}

@Component({
    selector: 'app-sms-details-dialog',
    templateUrl: './sms-details-dialog.component.html',
    styleUrls: ['./sms-details-dialog.component.scss'],
    standalone: false
})
export class SmsDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SmsDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SmsDetailsData,
    public lang: LanguageService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).catch(err => {
      console.error('Failed to copy:', err);
    });
  }
}
